var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDroplet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 82,
    viewBox: "0 0 68 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95901 71.5723C-3.31967 58.2949 -3.31967 36.7664 9.95901 23.4891L33.0566 0.390508C33.5775 -0.130169 34.4225 -0.130169 34.9421 0.390508L58.041 23.4891C71.3197 36.7664 71.3197 58.2949 58.041 71.5723C44.7636 84.8497 23.2364 84.8497 9.95901 71.5723Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4763 55.9533V39.1082L42.4232 34.0542H25.5768L20.5238 39.1082V55.9533L25.5768 61.0076H42.4232L47.4763 55.9533ZM35.6854 39.1082V45.846H42.4232V49.2155H35.6854V55.9533H32.3159V49.2155H25.5768V45.846H32.3159V39.1082H35.6854Z",
    fill: "url(#paint0_linear_79_111)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_111",
    x1: 47.4763,
    y1: 34.0542,
    x2: 20.5238,
    y2: 61.0076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1433D6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroplet);
export default __webpack_public_path__ + "static/media/droplet.45b28b10cb6fa2355696a88ce17e8723.svg";
export { ForwardRef as ReactComponent };